import { t } from '../../localization';

const getCaptions = (searchString, captionsOverrides) => ({
  title: captionsOverrides.title || t('Select domain for your website'),
  description:
    captionsOverrides.description ||
    t(
      'Improve the credibility of your site by connecting a custom domain. Visitors are 30% more likely to remember your site if it has a top-level domain'
    ),
  tabs: {
    domainsTitle: t('Buy new domain'),
    purchasedDomainsTitle: t('Use existing domain'),
  },
  search: {
    button: t('Search'),
    placeholder: t('Find your perfect domain'),
    errorMessage: t('Use only letters and numbers for domain name'),
  },
  errorMessage: t(
    'Sorry, <mark>{searchString}</mark> domain is already taken. But you may choose another domain',
    { searchString }
  ),
  backButton: captionsOverrides.closeButton || t('Back to editor'),
  nextButton: captionsOverrides.nextButton || t('Not now'),
});

export default getCaptions;
